import {takeLatest} from "redux-saga/effects";
import * as ActionsTypes from "../../../../common/constants/stateConstants";
import {
    excelExportSouscriptionSaga,
    generationBonCommandeSouscriptionSaga,
    getConsultationSouscriptionsListSaga,
} from "./consultationSouscriptionsSaga";

export default function* consultationSouscriptionsWatcher() {
  yield takeLatest(
    ActionsTypes.GET_CONSULTATION_SOUSCRIPTIONS_LIST,
    getConsultationSouscriptionsListSaga
  );
  yield takeLatest(
    ActionsTypes.GENERAL_EXCEL_SOUSCRIPTION_EXPORT,
    excelExportSouscriptionSaga
  );
  yield takeLatest(
    ActionsTypes.GENERATION_BON_COMMANDE_SOUSCRIPTION,
    generationBonCommandeSouscriptionSaga
  );
}
